import React, { useState, useEffect } from "react";
import Layout from "../Layout";
import { Link, useParams } from "react-router-dom";
import * as Unicons from "@iconscout/react-unicons";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Select } from "@chakra-ui/react";

const EditUser = () => {
  const { id } = useParams();
  const [passShow, setPassShow] = useState(false);
  const [cpassShow, setCpassShow] = useState(false);
  const [formData, setFormData] = useState({
    fname: "",
    email: "",
    password: "",
    cpassword: "",
  });

  const handleChange = (e, isLowercase) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: isLowercase ? value.toLowerCase() : value,
    });
  };

  const token = localStorage.getItem("usersdatatoken");
  const axiosConfig = {
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.fname || !formData.email) {
      toast.error("Please fill in all the details");
      return;
    }

    if (!validateEmail(formData.email)) {
      toast.error("Please enter a valid email address");
      return;
    }

    if (formData.password) {
      if (formData.password !== formData.cpassword) {
        toast.error("Password and Confirm Password do not match");
        return;
      }
      if (formData.password.length < 6) {
        toast.error("Password should be at least 6 characters long");
        return;
      }
    }

    try {
      const response = await axios.put(
        `${process.env.REACT_APP_BACK_URL}/api/user/edit/${id}`,
        formData,
        axiosConfig,
      );
      toast.success("User updated successfully");
      // Optionally, handle redirection or reset form state here
    } catch (error) {
      console.error(error.response ? error.response.data : error);
      toast.error("An error occurred");
    }
  };

  // Email validation function
  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACK_URL}/api/user/get/${id}`,
          axiosConfig,
        );
        const userData = response.data.user;
        setFormData({
          fname: userData.fname,
          email: userData.email,
          password: "",
          cpassword: "",
          type: userData?.type,
        });
      } catch (error) {
        console.error(
          "Error fetching user:",
          error.response ? error.response.data : error,
        );
      }
    };

    fetchUser();
  }, []);

  return (
    <Layout>
      <div className="flex items-center justify-center py-10 bg-slate-100 min-h-[88vh]">
        <div className="bg-white rounded-2xl border shadow-x1 p-10 w-full max-w-lg">
          <div className="flex items-center mb-8">
            <Link
              to="/user-list"
              className="bg-slate-100 w-10 h-10 rounded-full flex items-center justify-center"
            >
              <Unicons.UilArrowLeft size={25} />
            </Link>
            <h1 className="flex-grow pr-10 font-bold text-4xl text-gray-700 w-4/6 text-center">
              Update User
            </h1>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="flex flex-col items-center space-y-4">
              <input
                type="text"
                name="fname"
                placeholder="Name"
                value={formData.fname}
                onChange={handleChange}
                className="border-2 rounded-lg w-full h-12 px-4 focus:ring-0 focus:border-gray-500"
              />
              <input
                type="text"
                readOnly
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={(e) => handleChange(e, true)}
                className="border-2 rounded-lg w-full h-12 px-4 focus:ring-0 focus:border-gray-500 bg-gray-300"
              />
              <div className="relative w-full">
                <input
                  onChange={handleChange}
                  type={!passShow ? "password" : "text"}
                  value={formData.password}
                  name="password"
                  id="password"
                  placeholder={
                    !passShow ? "••••••••••••" : "New Password (optional)"
                  }
                  className="w-full border-2 rounded-lg h-12 block focus:ring-0 focus:border-gray-500"
                />
                <span
                  className="absolute inset-y-0 top-2 md:top-3 right-3"
                  onClick={() => setPassShow(!passShow)}
                >
                  {!passShow ? (
                    <Unicons.UilEye color="gray" />
                  ) : (
                    <Unicons.UilEyeSlash color="gray" />
                  )}
                </span>
              </div>
              <div className="relative w-full">
                <input
                  type={!cpassShow ? "password" : "text"}
                  name="cpassword"
                  placeholder={
                    !cpassShow ? "••••••••••••" : "Confirm New Password"
                  }
                  value={formData.cpassword}
                  onChange={handleChange}
                  className="w-full border-2 rounded-lg h-12 px-4 focus:ring-0 focus:border-gray-500"
                />
                <span
                  className="absolute inset-y-0 top-2 md:top-3 right-3"
                  onClick={() => setCpassShow(!cpassShow)}
                >
                  {!cpassShow ? (
                    <Unicons.UilEye color="gray" />
                  ) : (
                    <Unicons.UilEyeSlash color="gray" />
                  )}
                </span>
              </div>
              <Select
                placeholder="Select Role"
                required
                size={"lg"}
                colorScheme="teal"
                name="type"
                value={formData.type}
                onChange={handleChange}
                className="w-full h-12"
              >
                {["user", "admin", "superadmin", "designer"].map(
                  (role, idx) => (
                    <option
                      value={role}
                      key={role}
                      label={role.toLocaleUpperCase()}
                    >
                      {role}
                    </option>
                  ),
                )}
                {/* <option value={""} */}
              </Select>
              <button
                type="submit"
                className="bg-teal-500 text-white rounded-md hover:bg-teal-600 font-semibold px-4 py-3 w-full"
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </Layout>
  );
};

export default EditUser;
